/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useMemo } from 'react';
import { detect } from 'detect-browser';
import { lighten } from 'polished';
import { Capacitor } from '@capacitor/core';
export var BrowserBanner = function (_a) {
    var _b;
    var className = _a.className;
    var browser = useMemo(detect, []);
    var old = (browser === null || browser === void 0 ? void 0 : browser.name) === 'ie' && !window.msCrypto;
    var color = old ? '#b71a3e' : '#cc9d00';
    return (browser === null || browser === void 0 ? void 0 : browser.name) === 'edge-chromium' ||
        (browser === null || browser === void 0 ? void 0 : browser.name) === 'chrome' ||
        Capacitor.platform !== 'web' ? null : (jsx("div", { className: className, sx: {
            borderColor: color,
            borderWidth: 1,
            borderStyle: 'solid',
            bg: lighten(0.5, color),
            p: 3,
        } },
        jsx("div", { sx: { fontWeight: 'bold', mb: 3, fontSize: 3, color: color } }, old
            ? 'You are using an insecure browser'
            : 'Clara works best in Chrome and Edge'),
        old ? (jsx("div", { sx: { mb: 2 } },
            "Your browser was discontinued several years ago and no longer receives security updates. It is therefore",
            ' ',
            jsx("strong", { sx: { color: 'danger' } }, "not suitable to use for patient data"),
            ".")) : ((browser === null || browser === void 0 ? void 0 : browser.name) === 'ie' && (jsx("div", { sx: { mb: 2 } },
            "Microsoft replaced Internet Explorer with",
            ' ',
            jsx("a", { href: "https://www.microsoft.com/en-us/edge", sx: { color: color }, target: "_blank", rel: "noopener noreferrer" }, "Microsoft Edge"),
            ' ',
            "in 2015."))),
        (browser === null || browser === void 0 ? void 0 : browser.name) === 'edge' && (jsx("div", { sx: { mb: 2 } },
            "Microsoft released a",
            ' ',
            jsx("a", { href: "https://www.microsoft.com/en-us/edge", sx: { color: color }, target: "_blank", rel: "noopener noreferrer" }, "new version of Edge"),
            ' ',
            "in early 2020, which has better compatibility than the version you are using.")),
        jsx("div", null,
            "Clara might not work properly in your current browser \u2014 it works best in either",
            ' ',
            jsx("a", { href: "https://www.google.co.uk/chrome/", sx: { color: color }, target: "_blank", rel: "noopener noreferrer" }, "Google Chrome"),
            ' ',
            "or the latest version of",
            ' ',
            jsx("a", { href: "https://www.microsoft.com/en-us/edge", sx: { color: color }, target: "_blank", rel: "noopener noreferrer" }, "Microsoft Edge"),
            "."),
        (browser === null || browser === void 0 ? void 0 : browser.name) !== 'edge' && ((_b = browser === null || browser === void 0 ? void 0 : browser.os) === null || _b === void 0 ? void 0 : _b.includes('Windows')) && (jsx("div", { sx: { mt: 2 } }, "You probably already have Edge installed on your system \u2014 check for it in the Start menu."))));
};
//# sourceMappingURL=BrowserBanner.js.map